import React from "react";
import { File } from "lucide-react";
import { ReactComponent as PDFIcon } from "@assets/svg/paper-with-colon.svg";
import { ReactComponent as WordIcon } from "@assets/svg/paper-with-equals.svg";

interface FileIconProps {
  fileName: string;
  className?: string;
}

export const FileIcon: React.FC<FileIconProps> = ({ fileName, className }) => {
  const getFileIcon = () => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    
    if (extension === 'pdf') {
      return (
        <PDFIcon className={className} />
      );
    } else if (extension === 'doc' || extension === 'docx') {
      return (
        <WordIcon className={className} />
      );
    }

    // Default file icon
    return <File className={className} />;
  };

  return getFileIcon();
};
